<script setup>
import { useStore } from "vuex";
import { computed } from "vue";
import { n } from "components/jiffy/vue-cart/helpers/currency";
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";
import MoneyProgress from "./MoneyProgress.vue";

const store = useStore();
const totalsNoDiscount = computed(() => store.getters["product/totalsNoDiscount"]);
const freeShippingThreshold = computed(() => store.getters["product/freeShippingThreshold"]);
const isFreeShipping = computed(() => totalsNoDiscount.value - freeShippingThreshold.value > 0);
</script>

<template>
  <div class="shipping-free-bar">
    <div class="shipping-free-bar__header">
      <UseSvg class="shipping-free-bar__logo" icon="delivery" type="print" />
      <div v-if="isFreeShipping" class="shipping-free-bar__title">
        <span class="shipping-free-bar__threshold">Free Shipping!</span>
      </div>
      <div v-else class="shipping-free-bar__title">
        Free Shipping at
        <span class="shipping-free-bar__threshold">{{
          n(freeShippingThreshold, "currencyNoCents")
        }}</span>
      </div>
    </div>
    <MoneyProgress :max="freeShippingThreshold" :value="totalsNoDiscount" label="free shipping" />
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/pod/settings";

.shipping-free-bar {
  color: $pod-gray-modern-900;
  font-weight: 500;

  &__header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  &__logo {
    width: 22px;
    height: 18px;
  }

  &__threshold {
    color: $pod-date-orange;
    font-weight: 600;
  }
}
</style>
